<script setup lang="ts">
import ChangeDate from "@/modules/hotels/components/DetailsChangeDate.vue";
import useHotelGroupPolicies from "@/modules/hotels/composables/useHotelGroupPolicies";
import TopBarTab from "./TopBarTab.vue";
import type { DetailsTab } from "../interfaces/detailsTab";
import useGroup from '@/composables/useUserGroup';
import StyledPoliciesModal from '@/components/StyledPoliciesModal.vue';
import useUser from "@/modules/users/composables/useUser";
import { watch } from "vue";
import { computed } from "vue";

interface Props {
  tabs: DetailsTab[];
  loadButton: boolean;
  travelers: number[];
}

const props = defineProps<Props>();

const { user } = useUser({ params: { id: props.travelers[0] }, immediate: true })

const companyGroupId = computed(() => {
  return user.value?.companyGroupId;
})
// const { companyGroup, refetch } = useGroup({ params: { groupId: companyGroupId! }, immediate: false });

watch(user, async () => {
  // await refetch()
  await refetchPolicies()
})


const { policyObjectMapWithCountryNames, availablePolicies, refetchPolicies } = useHotelGroupPolicies({
  companyGroupId,
  immediate: false,
});
</script>

<template>
  <div :class="[
    ' center sticky top-16 z-10 w-full justify-start border-b border-gray-200 bg-white py-2 shadow-sm',
  ]">
    <div class="mx-auto flex justify-between w-full max-w-6xl items-center gap-4 px-4">
      <nav class="mt-2 flex min-w-0 gap-2 overflow-x-auto [scrollbar-width:none] md:gap-6">
        <TopBarTab v-for="tab in tabs" :key="tab.name" :tab="tab" />
      </nav>

      <StyledPoliciesModal v-if="availablePolicies" :policies="policyObjectMapWithCountryNames" class="hidden sm:block">
        <template #button>
          <p class="p-1.5 border text-sm rounded-md cursor-pointer">Ver políticas del grupo</p>
        </template>
      </StyledPoliciesModal>

      <!-- Change date -->
      <ChangeDate v-if="false" :load-button="loadButton" class-name="hidden md:flex" @handle-search="() => null" />
    </div>
  </div>

</template>

<style scoped></style>
